import { useEffect, useState } from 'react';
import HandleChange from '../../../../../Helpers/HandleChange';
import { FINES_MODEL, TIME_UNITS, UNIT_TYPE } from '../Model/Model';
import {useDispatch, useSelector} from 'react-redux';
import { getFineSettingsById, UpdateFineSettings } from '../../../../../reduxToolkit/FineManage/FineManageApi';
import { errorMsg } from '../../../../../Apis/functions';
import { STATUS_MODEL } from '../../../../../enums/statusEnum';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import {permissionObj} from "../../../../../Helpers/permission";
import { PERIOD_TIME_UNIT_ENUM } from '../../../../../enums/PeriodTimeUnitEnum';

/**
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 *
 * @Description
 * Custom React hook responsible for managing fine settings data and user interactions.
 * It handles data retrieval, updates, checkbox state toggling for notification methods,
 * and validation for required fields before updating.
 */

const FinesSubviewApp = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const [modified, setModified] = useState(false)
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const disabled = !DEV && !permission?.includes(permissionObj?.WEB_TRAFFIC_MANAGE_FINES_UPDATE);
    const [item, setItem] = useState({ ...FINES_MODEL });
    const [emptyFields, setEmptyFields] = useState(false);
    const { handleChange } = HandleChange({ model: item, setModel: setItem });

    /**
     * Toggles the activation status of a media option based on its ID.
     * If the option is currently inactive, it switches to active and vice versa.
     *
     * @param {number} mediaOptionId - The identifier for the media option being toggled.
     * @returns {void}
     */
    const handleCheckbox = (mediaOptionId) => {
        setItem((prevState) => ({
            ...prevState,
            mediaOptions: prevState.mediaOptions.map((option) =>
                option.mediaOptionId === mediaOptionId
                    ? {
                        ...option,
                        statusId:
                            option.statusId === STATUS_MODEL.IN_ACTIVE_COMPANY
                                ? STATUS_MODEL.ACTIVE_COMPANY
                                : STATUS_MODEL.IN_ACTIVE_COMPANY,
                    }
                    : option
            ),
        }));
    };

    const getData = () => {
        const body = {}
        dispatch(getFineSettingsById(body))
            .then(({ payload: { data: { data, code } } }) => {
                if (data?.id) {
                    setItem((prevState) => ({
                        ...prevState,
                        ...data
                    }));
                } else errorMsg(code);
            });
    }

    const updateData = () => {
        if (!item.isValid()) return setEmptyFields(true);

        const body = item;
        dispatch(UpdateFineSettings(body))
            .then(({ payload: { data: { data, code, success } } }) => {
                if (success) {
                    toast.success(t('has_been_updated_successfully'));
                    setModified(true);
                } else {
                    errorMsg(code);
                }
            })
    };


    const TIME_UNIT_TRANS = TIME_UNITS.map(el => ({
        ...el,
        name: t(el.name)
    }))

    const UNIT_TYPE_TRANS = UNIT_TYPE.map(el => ({
        ...el,
        name: t(el.name)
    }))

    const TIME_UNIT_NO_HOURS = TIME_UNITS.filter(el => el.id !== PERIOD_TIME_UNIT_ENUM.HOURS.name);

    const TIME_UNIT_NO_HOURS_TRANS = TIME_UNIT_NO_HOURS.map(el => ({
    ...el,
    name: t(el.name)
    }));

    useEffect(() => {
        if (modified) {
            getData();
            setModified(false)
        }
    }, [modified]);


    useEffect(() => {
        getData()
    }, [])


    return {
        handleChange,
        emptyFields,
        item,
        handleCheckbox,
        updateData,
        TIME_UNIT_TRANS,
        UNIT_TYPE_TRANS,
        disabled,
        TIME_UNIT_NO_HOURS_TRANS
    };
};

export default FinesSubviewApp;
